// extracted by mini-css-extract-plugin
export default {"wrapper":"FilePicker_wrapper__tNOmj","filePicker":"FilePicker_filePicker__IZV8O","input":"FilePicker_input__2TxSg"};